import { DEBUG_FEATURES } from "../utilities/constants"
import DevLogger from "./logger-dev"
import ProdLogger from "./logger-prod"

const logger = DEBUG_FEATURES ? DevLogger() : ProdLogger()
logger.info(`LOGGER is set for environment: ${DEBUG_FEATURES ? "DEBUG" : "PRODUCTION"}`)

export default logger
